import React from 'react';
import { GrowthSessionManagement as CorporateGrowthSessions } from '../Corporate/GrowthSessions';
import StandardGrowthSessions from './GrowthSessionManagement';

/**
 * GrowthSessionManagement Wrapper Component
 * Conditionally renders Corporate or Standard Growth Sessions based on environment variable
 */
const GrowthSessionManagementWrapper = () => {
    // Check if corporate mode is enabled
    const isCorporateMode = process.env.REACT_APP_CORPORATE_MODE === 'true';

    if (isCorporateMode) {
        // Render Corporate Growth Sessions
        return <CorporateGrowthSessions />;
    } else {
        // Render Standard Growth Sessions
        return <StandardGrowthSessions />;
    }
};

export default GrowthSessionManagementWrapper;
